export default {
  init() {

  },
  finalize() {
    $('.ld-breadcrumbs-segments span').each(function () {
      $(this).find('a').addClass('underline-hover');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/single.js